import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin, Observable, of, throwError, BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';
import { HelperService } from './helper.service';
import { catchError, map } from 'rxjs/operators';
import { EncryptionService } from "./encryption.service";
import { HttpService } from './httpService';


@Injectable({
    providedIn: 'root'
})
export class ApiService {

    baseUrl: string = environment.baseURL;
    private httpOptions: any;
    header: any;
    pagination = new BehaviorSubject(
        { search: '', page: 1, limit: 10, sortBy: '', sortKey: '', status: 1 }
    )
    constructor(private http: HttpService,
        private router: Router, private encryptionService: EncryptionService) {

        const pTokenData = this.encryptionService.getDataFromLocalStorage('NPToken');
        const setToken = JSON.parse(pTokenData);
        this.header = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + setToken

            })
        };
    }

    public getHeader(): any {
        const pTokenData = this.encryptionService.getDataFromLocalStorage('NPToken');
        const setToken = JSON.parse(pTokenData);
        if (setToken) {
            this.httpOptions = {
                headers: new HttpHeaders({
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + setToken
                }),
            };
        } else {
            this.httpOptions = {
                headers: new HttpHeaders({
                    Accept: 'application/json'
                }),
            };
        }
        return this.httpOptions;
    }

   

    getCountryList(): Observable<any> {
        return this.http.post('v2/procurement/countries', null);
    }

    getStatesList(data: any): Observable<any> {
        return this.http.post('v2/procurement/statesByCountry', data, this.getHeader()).pipe(catchError(this.handleAuthError)).pipe(catchError((x) => this.handleAuthError(x)));
    }

    getCitiesList(data: any): Observable<any> {
        return this.http.post('v2/procurement/cityByProvince', data, this.getHeader()).pipe(catchError(this.handleAuthError)).pipe(catchError((x) => this.handleAuthError(x)));
    }

    getSelectedProvince(id: any): Observable<any> {
        return this.http.post<any>('v2/procurement/provinceByStates', id);
    }

   
    getActivityLogList(data: any): Observable<any> {
        return this.http.post('procurement/supplier-activity', data, this.getHeader()).pipe(catchError(this.handleAuthError)).pipe(catchError((x) => this.handleAuthError(x)))
    }


    private handleAuthError(err: HttpErrorResponse): any {
        if (err.status === 401) {
            HelperService.onLogOut();
            const e = err.error;
            // window.location.href = '/';
        }
        return throwError(err);
    }


    logout() {
        return this.http.get('v1/order-management/customer/logout')
    }


    getManageCustomerList(data: any): Observable<any> {
        return this.http.post('v1/order-management/customer/customer-list', data);
    }

    deleteCustomer(data): Observable<any> {
        return this.http.post('v1/order-management/customer/delete-customer', data);
    }


    login(data: any): Observable<any> {
        return this.http.post('v1/order-management/customer/login', data);
    }

    registrationCustomer(data: any): Observable<any> {
        return this.http.post('v1/order-management/customer/customer-registration', data);
    }

    updateCustomer(data: any): Observable<any> {
        return this.http.post('v1/order-management/customer/edit-customer-profile', data);
    }

    getStatusCount() {
        return this.http.get('v1/order-management/customer/get-customer-count');
    }

    changeStatus(data: any): Observable<any> {
        return this.http.post('v1/order-management/customer/change-customer-status', data);
    }

    emailCheckService(email: any) {
        const payLoady = {
            email: email
        }
        return this.http.post('v1/order-management/customer/check-unique-email', payLoady)
    }

    getCustomerDetails(id): Observable<any> {
        return this.http.get('v1/order-management/customer/customer-details/' + id);
    }


    setPassword(data: any): Observable<any> {
        return this.http.post('v1/order-management/customer/change-password', data);
    }

    forgotPassword(data: any): Observable<any> {
        return this.http.post('v1/order-management/customer/forgot-password', data);
    }

    resetPassword(data: any): Observable<any> {
        return this.http.post('v1/order-management/customer/reset-password', data);
    }
    deleteProfile(id): Observable<any> {
        return this.http.get('v1/order-management/customer/delete-customer-account/' + id);
    }

}

export const StrongPasswordRegx: RegExp = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,20}$/;
